module.exports = __webpack_public_path__ + "img/colorDelete.5c3d4fe9.svg";